import type { Product, ProductPrice } from './model';
import { apiFetch } from '~/src/shared/api';

export async function apiGetProduct(productId: string) {
  return apiFetch<Product>(
    `/v1/sales/products/${productId}`,
  );
}
export async function apiGetProductPrice(priceId: string) {
  return apiFetch<ProductPrice>(
    `/v1/sales/prices/${priceId}`,
  );
}
